define("powergen/routes/systems",
  [],
  function() {
    "use strict";
    var SystemsRoute;

    SystemsRoute = Ember.Route.extend({
      model: function() {
        return this.get('store').find('game', 'main');
      }
    });


    return SystemsRoute;
  });